'use client';

import { useLocale } from 'next-intl';
import { useState } from 'react';

import SearchResultPost from './SearchResultPost';

import { LazyLoader } from '@components/Lazy';

interface SearchLazyLoaderProps {
  query: string;
  sortBy?: string;
  initialPage?: number;
}
export default function SearchLazyLoader({
  query,
  sortBy,
  initialPage = 1,
}: SearchLazyLoaderProps) {
  const [posts, setPosts] = useState<any[]>([]);
  const [page, setPage] = useState(initialPage);
  const [isEnd, setIsEnd] = useState(false);
  const locale = useLocale();

  const onChange = async (isVisible: boolean) => {
    if (!isVisible) {
      return;
    }

    const response = await fetch(
      `${
        process.env.NEXT_PUBLIC_API_PUBLIC
      }/search/${locale}?keywords=${query}&limit=10&page=${page}&sortBy=${sortBy || 'accuracy'
      }`,
    );

    if (!response.ok) {
      setIsEnd(true);
      return;
    }

    const data = await response.json();

    const result = data.searchResultsMap.post.searchResults;

    setPosts((_posts) => [..._posts, ...result]);
    setPage((page) => page + 1);

    if (result.length === 0) {
      setIsEnd(true);
    }
  };

  return (
    <>
      {posts.map((item) => (
        <SearchResultPost post={item} />
      ))}
      {!isEnd && (
        <div className="lg:col-span-2">
          <LazyLoader onChange={onChange} />
        </div>
      )}
    </>
  );
}
